import * as config from './../config/config'
import api from './interceptor'

export async function get_ListeTrajet() {
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LIST_TRAJET);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Création : multipart/form-data (le backend lit request.form + request.files.getlist("pj"))
export async function addTrajet(data) {
  try {
    const formData = new FormData();

    formData.append("date_depart", data.date_depart || "");
    formData.append("date_arrive", data.date_arrive || "");
    formData.append("nb_jours", data.nb_jours ?? "");
    formData.append("description", data.description || "");
    formData.append("facture_id", data.facture_id);
    formData.append("kilometrage", data.kilometrage);
    formData.append("fond_de_cuve", data.fond_de_cuve);
    formData.append("appro", data.approvisionnement);
    formData.append("statut", data.statut);
    formData.append("camion_ids", data.camion_ids);

 
    (data.pieces_jointes || [])
      .filter((file) => file.originFileObj)
      .forEach((file) => {
        formData.append("pj", file.originFileObj); // le backend attend "pj", pas "pieces_jointes"
      });
    const response = await api.post(
      config.REACT_APP_ENDPOINT_CREATE_TRAJET,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur API addTrajet:", error);
    throw error;
  }
}

// Mise à jour : JSON (le backend lit request.get_json())
export async function updateTrajet(data) {
  try {
    const response = await api.put(
      `${config.REACT_APP_ENDPOINT_UPDATE_TRAJET}/${data.id}`,
      {
        date_depart: data.date_depart,
        date_arrive: data.date_arrive,
        nb_jours: data.nb_jours,
        description: data.description,
        facture_id: data.facture_id,
        // pj: [...] → uniquement si tu renvoies la liste des chemins déjà existants à conserver.
        // L'ajout de nouveaux fichiers en modification n'est pas géré par cette route actuellement.
      },
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur API updateTrajet:", error);
    throw error;
  }
}

// Gestion des camions d'un trajet (routes dédiées, séparées de update)
export async function addCamionToTrajet(trajetId, camionId, statut = "en_cours") {
  const response = await api.post(`${config.REACT_APP_ENDPOINT_TRAJET_CAMION}/${trajetId}/camion`, {
    camion_id: camionId,
    statut,
  });
  return response.data;
}

export async function removeCamionFromTrajet(trajetId, camionId) {
  const response = await api.delete(
    `${config.REACT_APP_ENDPOINT_TRAJET_CAMION}/${trajetId}/camion/${camionId}`
  );
  return response.data;
}



// Historique : multipart/form-data (le backend lit request.form + request.files.getlist("pj"))
export async function addHistoriqueTrajet(data) {
  try {
    const formData = new FormData();

    formData.append("date_arrive", data.date_arrive || "");
    formData.append("camion_ids", data.camion_id);
    formData.append("trajet_id", data.trajet_id);
    formData.append("kilometrage", data.kilometrage);
    formData.append("fond_de_cuve", data.fond_de_cuve);
    formData.append("description", data.description || "");

    (data.pieces_jointes || [])
      .filter((file) => file.originFileObj)
      .forEach((file) => {
        formData.append("pj", file.originFileObj);
      });

    const response = await api.post(
      config.REACT_APP_ENDPOINT_CREATE_HISTORIQUE_TRAJET,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur API addHistoriqueTrajet:", error);
    throw error;
  }
}